import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fhvkbnbjnorsmsvrjizl.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZodmtibmJqbm9yc21zdnJqaXpsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUwNTkxMTksImV4cCI6MjA5MDYzNTExOX0.Me-mGgDne3N9UadHPbv3ubAIlihG4fkVizvQ94k4Emw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);